/**
 * @module cercaliagl/view/VWidgetPois
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import { MDCTabBar } from '@material/tab-bar';
import { MDCSlider } from '@material/slider';
import BaseView, { EventType as BaseViewEventType } from './BaseView';
import { createCheckbox, createTabBar, createRadiobox, createSlider, } from './VUtils';
import { i18n } from '../dictionary';
import { createUid, isMobile } from '../util';
/**
 * @typedef {Object} PoisSearchOptions
 * @property {Array.<string>} categories Categories
 * @property {number} distance Distance
 * @property {number} numCand Num candidates
 * @property {string} searchType Type search. By address or by map center.
 * @property {import("../servers.js").GeEntity} [ge] Geo entity
 */
/**
 * @enum {string}
 */
export var EventType = {
    CATEGORIES_CHANGED: 'categories_changed',
    CLOSE_POIS: 'pois_close',
    POIS_SEARCH: 'pois_search',
    SEARCH_TYPE_CHANGED: 'searchtype_changed',
    MINIMIZE: 'minimize',
};
/**
 * @enum {string}
 */
export var Mode = {
    VIEW_MAP: 'view_map',
    PROXIMITY: 'proximity',
};
/**
 * @enum {string}
 */
export var SearchType = {
    ADDRESS: 'address',
    MAP_CENTER: 'map_center',
};
/**
 * @enum {number}
 */
var DistanceValues = {
    MIN: 1,
    MAX: 50,
    DEFAULT: 25,
};
/**
 * @enum {number}
 */
var CandidatesValues = {
    MIN: 1,
    MAX: 300,
    DEFAULT: 100,
};
/**
 * @enum {number}
 */
var Tabs = {
    VIEW_MAP: 0,
    PROXIMITY: 1,
};
/**
 * @classdesc
 */
var VWidgetPois = /** @class */ (function (_super) {
    __extends(VWidgetPois, _super);
    /**
     * @constructor
     */
    function VWidgetPois() {
        var _this = this;
        var jqElement = $("\n      <div class=\"v-widgetpois mdc-elevation--z4\">\n        <div class=\"header\">\n          ".concat(createTabBar([i18n('viewOnMap'), i18n('proximity')]), "\n          <div class=\"btn-close\">\n            <button type=\"button\" class=\"mdc-icon-button close\">\n              <span class=\"mdc-icon-button__icon icon-close\"></span>\n            </button>\n          </div>\n        </div>\n        <div class=\"content\">\n          <div class=\"prox-inputs\">\n            <div class=\"row radio-typesearch\">\n              <div class=\"column\">\n                ").concat(createRadiobox('typeSearch', SearchType.ADDRESS, true, i18n('searchAddress'), true), "\n              </div>\n              <div class=\"column\">\n                ").concat(createRadiobox('typeSearch', SearchType.MAP_CENTER, true, i18n('mapCenter'), false), "\n              </div>\n            </div>\n            <div class=\"text-center\">\n              <div id=\"poisAutocomplete").concat(createUid(), "\" class=\"autocomplete\"></div>\n            </div>\n            <div class=\"dist-box\">\n              <div class=\"slider-title\">").concat(i18n('distance'), "</div>\n              ").concat(createSlider('distance', DistanceValues.MIN, DistanceValues.MAX, DistanceValues.DEFAULT, true, 'Km'), "\n            </div>\n            <div class=\"numCand-box\">\n              <div class=\"slider-title\">").concat(i18n('searchCandidates'), "</div>\n              ").concat(createSlider('numCand', CandidatesValues.MIN, CandidatesValues.MAX, CandidatesValues.DEFAULT, true, ' '), "\n            </div>\n            <div class=\"text-right\">\n              <button type=\"button\" class=\"mdc-button refresh\">\n                <span class=\"mdc-button__ripple\"></span>\n                <span class=\"mdc-button__label\">").concat(i18n('searchSearchBtn'), "</span>\n              </button>\n            </div>\n          </div>\n          <div class=\"cat-cont\">\n          </div>\n        </div>\n      </div>\n    "));
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqProxInputs_ = _this.jqElement_.find('.prox-inputs');
        /**
         * @private
         * @type {JQuery}
         */
        _this.jqCategoriesDiv_ = _this.jqElement_.find('.cat-cont');
        /**
         * @private
         * @type {number}
         */
        _this.currentTab_ = Tabs.VIEW_MAP;
        /**
         * @private
         * @type {MDCSlider}
         */
        _this.mdcSliderDist_ = null;
        /**
         * @private
         * @type {MDCSlider}
         */
        _this.mdcSliderNumCand_ = null;
        /**
         * @private
         * @type {Array.<string>}
         */
        _this.categories_ = [];
        /**
         * @private
         * @type {import("../servers.js").GeEntity}
         */
        _this.ge_ = null;
        /**
         * @private
         * @type {PoisSearchOptions}
         */
        _this.searchOptions_ = {
            categories: [],
            distance: DistanceValues.DEFAULT * 1000,
            numCand: CandidatesValues.DEFAULT,
            searchType: SearchType.ADDRESS,
            ge: null,
        };
        _this.initialize_();
        return _this;
    }
    /**
     * @private
     */
    VWidgetPois.prototype.initialize_ = function () {
        var _this = this;
        if (!this.jqElement_) {
            return;
        }
        var jqButtonClose = this.jqElement_.find('button.close');
        var jqButtonRefresh = this.jqElement_.find('button.refresh');
        if (!jqButtonClose || !jqButtonRefresh) {
            return;
        }
        jqButtonClose.click(function () { return _this.emit(EventType.CLOSE_POIS); });
        jqButtonRefresh.click(function () {
            _this.searchOptions_.ge = _this.searchOptions_.searchType === SearchType.ADDRESS ? _this.ge_ : undefined;
            _this.emit(EventType.POIS_SEARCH, _this.searchOptions_);
        });
        this.on(BaseViewEventType.ATTACHED, function () {
            if (!_this.jqElement_) {
                return;
            }
            var jqTabBar = _this.jqElement_.find('.mdc-tab-bar');
            if (!jqTabBar || jqTabBar.length === 0) {
                return;
            }
            _this.adjustByDevice();
            var tabBar = new MDCTabBar(jqTabBar.get(0));
            tabBar.activateTab(0);
            tabBar.listen('MDCTabBar:activated', function (e) {
                _this.currentTab_ = e.detail.index;
                if (_this.currentTab_ === Tabs.VIEW_MAP) {
                    _this.jqProxInputs_.hide();
                }
                else if (_this.currentTab_ === Tabs.PROXIMITY) {
                    _this.jqProxInputs_.show();
                    if (!_this.mdcSliderDist_) {
                        _this.mdcSliderDist_ = new MDCSlider(_this.jqElement_.find('.distance').get(0));
                        _this.mdcSliderDist_.listen('MDCSlider:change', function () {
                            var dist = _this.mdcSliderDist_.getValue();
                            _this.jqElement_.find('.distance .value').text("".concat(dist, "Km"));
                            _this.searchOptions_.distance = dist * 1000;
                        });
                    }
                    if (!_this.mdcSliderNumCand_) {
                        _this.mdcSliderNumCand_ = new MDCSlider(_this.jqElement_.find('.numCand').get(0));
                        _this.mdcSliderNumCand_.listen('MDCSlider:change', function () {
                            var numCand = _this.mdcSliderNumCand_.getValue();
                            _this.jqElement_.find('.numCand .value').text("".concat(numCand));
                            _this.searchOptions_.numCand = numCand;
                        });
                    }
                }
            });
            _this.jqElement_.find('input[name=typeSearch]').change(function (e) {
                var searchType = e.target.value;
                _this.searchOptions_.searchType = searchType;
                _this.emit(EventType.SEARCH_TYPE_CHANGED, searchType);
            });
        });
    };
    /**
     * Adjust by device
     */
    VWidgetPois.prototype.adjustByDevice = function () {
        var viewport = this.getMapViewport();
        this.jqElement_.css('width', !isMobile() ? 'auto' : viewport.offsetWidth - 10);
        var mapHeight = viewport.offsetHeight;
        this.jqElement_.find('.content').css('maxHeight', mapHeight - 70);
    };
    /**
     * @param {import("../servers.js").GeEntity} ge GeEntity
     */
    VWidgetPois.prototype.setGeoEntity = function (ge) {
        this.ge_ = ge;
    };
    /**
     * @return {Element} Element
     */
    VWidgetPois.prototype.getAutocomplete = function () {
        return this.jqElement_.find('div.autocomplete').get(0);
    };
    /**
     * @param {Array.<Object>} cats Categories from JSON
     */
    VWidgetPois.prototype.setCategories = function (cats) {
        var _this = this;
        cats.forEach(function (cat) {
            if (cat.id === 'traffic')
                return;
            var jqCatDiv = $("\n        <div class=\"groupcat ".concat(cat.id, "\">\n          <div class=\"btn-collapse\">").concat(cat.name, "</div>\n          <ul class=\"collapse ").concat(cat.id, "\">\n            ").concat(cat.subcats.map(function (subcat) { return "<li>".concat(createCheckbox(subcat.name, subcat.id, "<span class=\"icon icon-".concat(subcat.id.replace('|', ''), "\"></span><span class=\"text\">").concat(subcat.name, "</span>"), false), "</li>"); }).join(''), "\n          </ul>\n        </div>"))
                .appendTo(_this.jqCategoriesDiv_);
            jqCatDiv.find('div.btn-collapse').click(function (e) {
                _this.jqCategoriesDiv_.find('ul.collapse').each(function (index, elem) {
                    if (e.currentTarget.nextElementSibling === elem) {
                        $(e.currentTarget).next().toggle();
                    }
                    else {
                        $(elem).hide();
                    }
                });
            });
        });
        this.jqCategoriesDiv_.find('li input[type=checkbox]').change(function (e) {
            var checkbox = e.currentTarget;
            var subcat = checkbox.value;
            if (checkbox.checked) {
                _this.categories_.push(subcat);
            }
            else {
                var index = _this.categories_.indexOf(subcat);
                _this.categories_.splice(index, 1);
            }
            _this.searchOptions_.categories = _this.categories_;
            if (_this.currentTab_ === Tabs.VIEW_MAP) {
                _this.emit(EventType.CATEGORIES_CHANGED, _this.categories_);
            }
        });
    };
    /**
     * Uncheck all
     */
    VWidgetPois.prototype.uncheckAll = function () {
        this.jqCategoriesDiv_.find('li input[type=checkbox]').prop('checked', false);
        this.searchOptions_.categories = [];
        this.emit(EventType.CATEGORIES_CHANGED, []);
    };
    return VWidgetPois;
}(BaseView));
export default VWidgetPois;
//# sourceMappingURL=VWidgetPois.js.map